var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFootballPlanscreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon othersSVGs",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 18.5977C14.4706 18.5977 18.5 14.5682 18.5 9.59766C18.5 4.62709 14.4706 0.597656 9.5 0.597656C4.52944 0.597656 0.5 4.62709 0.5 9.59766C0.5 14.5682 4.52944 18.5977 9.5 18.5977ZM3.96154 4.7515L4.65385 7.52073L1.88462 10.9823L2.57692 13.0592L6.03846 13.7515L8.11538 17.213H10.1923L12.2692 13.7515L16.4231 12.3669V10.29L14.3462 8.21304V4.05919L12.2692 2.67458L10.5385 4.05919H8.11538L6.03846 3.02073L3.96154 4.7515Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73071 9.5976L8.80764 6.82837H10.1923L12.2692 9.5976L11.2307 12.3668H7.76917L6.73071 9.5976Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballPlanscreen);
export default __webpack_public_path__ + "static/media/football-planscreen.981b81481cd3e3383298f0de95add5e6.svg";
export { ForwardRef as ReactComponent };